import { render, staticRenderFns } from "./IconSettingsOutline.vue?vue&type=template&id=fb953d18"
import script from "./IconSettingsOutline.vue?vue&type=script&lang=js"
export * from "./IconSettingsOutline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports